(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('projectTaskCtrl', projectTaskCtrl);

	projectTaskCtrl.$inject = ['$scope', '$rootScope', '$timeout', '$filter', '$compile', 'myWorkService', 'storeService', 'notificationService'];

	function projectTaskCtrl($rootScope, $scope, $timeout, $filter, $compile, myWorkService, storeService, notificationService) {
		$scope.loadTask = loadTask;
		$scope.projectTask = {};
		$scope.display = {};
		$scope.display.loading = true;
		$scope.inlineEditing = {};
		$scope.inlineActive = false;
		$scope.originalProjectTask = {};
		$scope.dueDateChange = dueDateChange;
		$scope.dueDateAfterProjectDueDate = false;
		$scope.doChooseColumns = true;

		var statusList = [{
			'name': 'Pending'
		}, {
			'name': 'Started'
		}, {
			'name': 'Completed'
		}];
		var percentCompleteList = [];
		var lastModified;

		for (var i = 0; i <= 100; i += 5) {
			percentCompleteList.push({
				'value': i,
				'display': i + '%'
			});
		}

		$scope.lists = {};
		$scope.lists.statusObj = statusList;
		$scope.lists.percentCompleteObj = percentCompleteList;
		$scope.startEditText = startEditText;
		$scope.startEditNumber = startEditNumber;
		$scope.startEditTextArea = startEditTextArea;
		$scope.startEditList = startEditList;
		$scope.startEditDate = startEditDate;
		$scope.cancelInlineEdit = cancelInlineEdit;
		$scope.saveInlineEdit = saveInlineEdit;

		var variableLabel = {
			'name': 'Task Name',
			'description': 'Description',
			'action': 'Detailed Actions',
			'percentComplete': 'Percent Complete',
			'statusObj': 'Status',
			'projectedCompleteDate': 'Projected Complete Date'
		};
		var opsFactNdx;

		function loadTask(taskNdx, factoryNdx, projectNdx) {
			$scope.projectTask = {};
			opsFactNdx = factoryNdx;
			var currentTask = myWorkService.getTask();
			myWorkService.getProjectTask(taskNdx, projectNdx || currentTask.parentNdx, factoryNdx).then(function (response) {
				$scope.display.loading = false;
				var headers = response.headers();
				var data = response.data;
				lastModified = (typeof data.lastModified === 'undefined') ? (new Date()).toUTCString(): (new Date(data.lastModified)).toUTCString();
				if (data) {					
					$scope.projectTask = data;
					$scope.projectTask.statusObj = {
						'name': $scope.projectTask.stateType
					};
					$scope.projectTask.percentCompleteObj = {
						'value': $scope.projectTask.percentComplete,
						'display': $scope.projectTask.percentComplete + '%'
					};
					$scope.projectTask.projectName = currentTask.projectName;
					$scope.projectTask.projectId = currentTask.projectId;
					$scope.projectTask.projectNdx = currentTask.parentNdx;
					$scope.projectTask.projectedCompleteDate = new Date($scope.projectTask.projectedCompleteDate);
					var projectedCompleteDateLocal = moment($scope.projectTask.projectedCompleteDate).add($scope.projectTask.projectedCompleteDate.getTimezoneOffset(), 'minutes');
					$scope.projectTask.projectedCompleteDate = moment(projectedCompleteDateLocal)._d;
					$scope.originalTask = jQuery.extend({},$scope.projectTask, true);
				}
			});
		}

		function getTextTemplate(position, variableName, variableDisplay, maxLength) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var editTemplate = '<div class="inlineEditDiv absolute textEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">Change ' + variableDisplay + '</div>' +
				'<div class="input-holder-with-clear">' +
				'<input class="inlineEditInput with-clear" ng-model="inlineEditing.' + variableName + '" />' +
				'<span class="input-clear" ng-show="inlineEditing.' + variableName + ' && inlineEditing.' + variableName + '.length" ng-click="inlineEditing.' + variableName + ' = \'\'"><i class="fa fa-times"></i></span>' +
				'</div>' +
				(typeof maxLength !== 'undefined' ? '<span class="error-desc" ng-if="inlineEditing.' + variableName + '.length>' + maxLength + '">Max allowed characters are ' + maxLength + '.</span>' : '') +
				'<div class="inlineEditButtons"><button class="button flat" ng-click="cancelInlineEdit(' + "'" + variableName + "'" + ')">Cancel</a>' +
				'<button class="button flat colored" ng-disabled="(!inlineEditing.' + variableName + ' || !inlineEditing.' + variableName + '.length ' + (typeof maxLength !== 'undefined' ? ' || inlineEditing.' + variableName + '.length>' + maxLength + ' ' : '') + ') && !(inlineEditing.' + variableName + ' === false)" ng-click="' + (typeof maxLength !== 'undefined' ? '!(inlineEditing.' + variableName + '.length>' + maxLength + ') && ' : '') + ' saveInlineEdit(' + "'" + variableName + "'" + ')">Save</a></div></div>';
			return editTemplate;
		}

		function getNumberTemplate(position, variableName, variableDisplay) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var editTemplate = '<div class="inlineEditDiv absolute textEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">Change ' + variableDisplay + '</div>' +
				'<input class="inlineEditInput" ng-model="inlineEditing.' + variableName + '" type="number" min="0" max="100" ng-min="0" ng-max="100" step="1" ng-step="1" />' +
				'<div class="inlineEditButtons"><button class="button flat" ng-click="cancelInlineEdit(' + "'" + variableName + "'" + ')">Cancel</a>' +
				'<button class="button flat colored" ng-disabled="(!inlineEditing.' + variableName + ')" ng-click="saveInlineEdit(' + "'" + variableName + "'" + ')">Save</a></div></div>';
			return editTemplate;
		}
		
		function getTextAreaTemplate(position, variableName, variableDisplay) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 408 > windowWidth) {
				position.left = position.left - (position.left + 408 - windowWidth - 8);
			}
			if (position.top + 140 > windowHeight) {
				position.top = position.top - (position.top + 140 - windowHeight - 8);
			}
			var editTemplate = ''
				+ '<div class="inlineEditDiv absolute textAreaEdit myTasksView" style="top:' + position.top + 'px; left: ' + position.left + 'px;">'
				+ 	'<div class="inlineEditHeader">'
				+ 		'Change ' + variableDisplay
				+ 	'</div>'
				+ 	'<textarea style="max-height: 60px; height: 100%;" class="inlineEditInput" ng-model="inlineEditing.' + variableName + '" ></textarea>'
				+ 	'<div class="inlineEditButtons">'
				+ 		'<button class="button flat" ng-click="cancelInlineEdit(' + "'" + variableName + "'" + ')">'
				+ 			'Cancel'
				+ 		'</button>'
				+ 		'<button class="button flat colored" ng-click="saveInlineEdit(' + "'" + variableName + "'" + ')">'
				+ 			'Save'
				+ 		'</button>'
				+ 	'</div>'
				+ '</div>';
			return editTemplate;
		}

		function getListTemplate(position, variableName, variableDisplay, display) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			var width = 296;
			var extraClass = '';

			if (position.left + width > windowWidth) {
				position.left = position.left - (position.left + width - windowWidth - 8);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}

			var filter = 'filter: $select.search';

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv absolute textEdit" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader">Change ' + variableDisplay + '</div>' +
				'<ui-select append-to-body="true" theme="bootstrap" ng-model="inlineEditing.' + variableName + '">' +
				'<ui-select-match placeholder="{{' + "'Select " + variableDisplay + "...'" + ' | translate}}">' +
				'{{$select.selected.' + display + '}}' +
				'</ui-select-match>' +
				'<ui-select-choices repeat="item in lists.' + variableName + ' | ' + filter + '">' +
				'{{item.' + display + '}}' +
				'</ui-select-choices>' +
				'</ui-select>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="cancelInlineEdit(' + "'" + variableName + "'" + ')">Cancel</button>' +
				'<button class="button flat colored" ng-disabled="!inlineEditing.' + variableName + ' && !(inlineEditing.' + variableName + ' === false)" ng-click="saveInlineEdit(' + "'" + variableName + "')" + '">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function getDateTemplate(position, variableName, variableDisplay) {
			var windowWidth = jQuery('#' + variableName).width();
			var windowHeight = jQuery('.details-container').height() - 49;
			if (position.left + 340 > windowWidth) {
				position.left = position.left - (position.left + 340 - windowWidth - 8);
			}
			if (position.top + 356 > windowHeight) {
				position.top = position.top - (position.top + 356 - windowHeight - 8);
			}
			var editTemplate = '<div class="inlineEditDiv absolute dateEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">Choose a ' + variableDisplay + '</div>' +
				'<div uib-datepicker ng-model="inlineEditing.' + variableName + '" class="well well-sm" ng-change="dueDateChange(' + "'" + variableName + "'" + ')"></div>' +
				'<div class="inlineEditButtons">' +
				'<a class="button flat" ng-click="cancelInlineEdit(' + "'" + variableName + "'" + ')">Cancel</a>' +
				'<a class="button flat colored" ng-click="saveInlineEdit(' + "'" + variableName + "'" + ')">Save</a></div></div>';
			return editTemplate;
		}

		function startEditText(variableName, maxLength) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + variableName);
			var pos = cell.position();
			var content = $scope.projectTask[variableName];
			var editTemplate = getTextTemplate(pos, variableName, variableLabel[variableName], maxLength);
			$scope.inlineEditing[variableName] = content;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#' + variableName).parent().append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					if (typeof maxLength !== 'undefined' && $scope.inlineEditing[variableName] && $scope.inlineEditing[variableName].length > 255) {
						return;
					}
					$scope.saveInlineEdit(variableName);
				} else if (code == 27) {
					$scope.cancelInlineEdit(variableName);
				}
			});
			jQuery('.inlineEditDiv input').focus();
			$scope.inlineActive = true;
		}

		function startEditNumber(variableName) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + variableName);
			var pos = cell.position();
			var content = $scope.projectTask[variableName];
			var editTemplate = getNumberTemplate(pos, variableName, variableLabel[variableName]);
			$scope.inlineEditing[variableName] = content;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#' + variableName).parent().append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					$scope.saveInlineEdit(variableName);
				} else if (code == 27) {
					$scope.cancelInlineEdit(variableName);
				}
			});
			jQuery('.inlineEditDiv input').focus();
			$scope.inlineActive = true;
		}
		
		function startEditTextArea(variableName) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + variableName);
			var content = $scope.projectTask[variableName];
			var pos = cell.position();
			var editTemplate = getTextAreaTemplate(pos, variableName, variableLabel[variableName]);
			$scope.inlineEditing[variableName] = content;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#' + variableName).parent().append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 27) {
					$scope.cancelInlineEdit(variableName);
				}
			});
			jQuery('.inlineEditDiv textarea').focus();
			$scope.inlineActive = true;
		}

		function startEditList(variableName, display) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + variableName);
			var pos = cell.position();
			var content = $scope.projectTask[variableName];
			var editTemplate = getListTemplate(pos, variableName, variableLabel[variableName], display);
			$scope.inlineEditing[variableName] = content;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#' + variableName).parent().append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					$scope.saveInlineEdit(variableName);
				} else if (code == 27) {
					$scope.cancelInlineEdit(variableName);
				}
			});
			jQuery('.inlineEditDiv input').focus();
			$scope.inlineActive = true;
		}

		function startEditDate(variableName) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + variableName);
			var pos = cell.position();
			var content = $scope.projectTask[variableName];
			var editTemplate = getDateTemplate(pos, variableName, variableLabel[variableName]);
			$scope.inlineEditing[variableName] = content;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#' + variableName).parent().append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					$scope.saveInlineEdit(variableName);
				} else if (code == 27) {
					$scope.cancelInlineEdit(variableName);
				}
			});
			$scope.inlineActive = true;
		}

		function cancelInlineEdit(variableName) {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			$scope.inlineActive = false;
		}

		function updatePercentComplete(projectTaskObj) {
			if ($scope.originalTask.stateType !== projectTaskObj.stateType) {
				if ($scope.originalTask.stateType === 'Completed' && projectTaskObj.stateType !== 'Completed') { 
					projectTaskObj.percentComplete = 0;
					return;
				}
				if (projectTaskObj.stateType === 'Pending') {
					projectTaskObj.percentComplete = 0;
				}
			}
		}

		function saveInlineEdit(variableName) {
			var content = $scope.inlineEditing[variableName];
			var oldVal = $scope.projectTask[variableName];
			$scope.projectTask[variableName] = content;
			var allowEdit = true;
			var errorMessage = '';
			if (!content && content != false) {
				allowEdit = false;
				errorMessage = 'Please enter a value for ' + variableLabel[variableName];
			}

			if (allowEdit) {
				var projectTaskObj = {};
				var projectedCompleteDateUtc = moment($scope.projectTask.projectedCompleteDate).subtract($scope.projectTask.projectedCompleteDate.getTimezoneOffset(), 'minutes');
				$scope.projectTask.projectedCompleteDate = moment($scope.projectTask.projectedCompleteDate)._d;
				projectTaskObj.name = $scope.projectTask.name;
				projectTaskObj.description = $scope.projectTask.description;
				projectTaskObj.projectedCompleteDate = moment(projectedCompleteDateUtc)._d;
				projectTaskObj.percentComplete = $scope.projectTask.percentComplete;
				projectTaskObj.stateType = $scope.projectTask.statusObj.name;
				projectTaskObj.action = $scope.projectTask.action;
				projectTaskObj.ndx = $scope.projectTask.ndx;
				projectTaskObj.taskResponsibleId = $scope.projectTask.taskResponsibleId;
				updatePercentComplete(projectTaskObj);
				var tableName = myWorkService.getTask().tableName;
				var fromMyWorkTab = myWorkService.getTask().fromMyWorkTab;
				if (!angular.equals($scope.originalTask, $scope.projectTask)) {	
					var formattedLastModified = (new Date(lastModified)).toUTCString();
					myWorkService.updateProjectTask(projectTaskObj, $scope.projectTask.projectNdx, opsFactNdx, formattedLastModified).then(function (response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$rootScope.$emit('toast', {
								'message': variableLabel[variableName] + ' saved successfully.'
							});
							if (variableName == 'name' && fromMyWorkTab) { 
								storeService.dispatch(storeService.actionCreators.myProjectTasks.updateTaskSubject(
									{ taskNdx: projectTaskObj.ndx, subject: projectTaskObj.name, type: 'Task' }));
							}
							if (variableName == 'projectedCompleteDate') {
								$scope.dueDateAfterProjectDueDate = false;
								$rootScope.$emit('dueDateUpdated', {
									'newDueDate': $scope.projectTask.projectedCompleteDate
								});
								if (fromMyWorkTab) {
									storeService.dispatch(storeService.actionCreators.myProjectTasks.getMyProjectTasks(
										{ assignee: globalConfig.user.id, firstLoad: false, tableName: tableName }));
								}
							}
							if (variableName == 'statusObj') {
								$rootScope.$emit('taskIssueStatusUpdated', {
									'newStateType': $scope.projectTask.statusObj.name
								});
								if (fromMyWorkTab) {
									notificationService.getUnreadInventoryActions(true);
									storeService.dispatch(storeService.actionCreators.myProjectTasks.getMyProjectTasks(
										{ assignee: globalConfig.user.id, firstLoad: false, tableName: tableName }));
								}
							}
							if (variableName == 'percentComplete' && $scope.projectTask.percentComplete === 100) {
								$rootScope.$emit('taskIssueStatusUpdated', {
									'newStateType': 'Completed'
								});
								if (fromMyWorkTab) {
									notificationService.getUnreadInventoryActions(true);
									storeService.dispatch(storeService.actionCreators.myProjectTasks.getMyProjectTasks(
										{ assignee: globalConfig.user.id, firstLoad: false, tableName: tableName }));
								}
							}
							loadTask($scope.projectTask.ndx, opsFactNdx);
						} else if (response && response.status == 412) {
							$scope.projectTask[variableName] = oldVal;
							$rootScope.$emit('toast', {
								'message': 'This task has been updated since you loaded the page, please refresh the page',
								'success': false
							});
						} else {
							$scope.projectTask[variableName] = oldVal;
							$rootScope.$emit('toast', {
								'message': 'Unexpected server error',
								'success': false
							});
						}
					});
				}
			} else {
				$scope.projectTask[variableName] = oldVal;
				$rootScope.$emit('toast', {
					'message': errorMessage,
					'success': false
				});
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			$scope.inlineActive = false;
		}

		function dueDateChange(variableName) {
			var taskDate = variableName == null ? moment($scope.projectTask.projectedCompleteDate) : moment($scope.inlineEditing[variableName]);
			if (taskDate != null && taskDate.isValid()) {
				var projectDate = moment(myWorkService.getTask().projectEndDate);
				var result = (moment(taskDate).isAfter(projectDate, 'days'));
				$scope.dueDateAfterProjectDueDate = result;
				$scope.tempCompleteDate = taskDate._d;
			}
		}
	}
})();
